<template>
  <div>
    <vs-row vs-type="block" vs-w="12">
      <vs-popup fullscreen :active.sync="isActive" id="paymentRequests" title="Ödeme İstekleri">
        <div class="table-responsive">
          <table class="vs-table">
            <thead>
              <tr>
                <th>Id</th>
                <th>Masa No</th>
                <th>Toplam Tutar</th>
                <th>Oluşturulma Tarihi</th>
                <th>Ürünler</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="request in requests" :key="request.id">
                <td>{{ request.id }}</td>
                <td>{{ request.table }}</td>
                <td>{{ request.amount }} ₺</td>
                <td>{{ request.created }}</td>
                <td>
                  <ul class="pavo-products-list">
                    <li v-for="(item, index) in request.items" :key="index">
                      {{ item.productName }}
                    </li>
                  </ul>
                </td>
                <td>
                  <vs-button style="background-color: #ff0000 !important; color: #fff !important;"
                    type="border"
                    size="small"
                    @click="confirmDelete(request.id)"
                  >
                    Sil
                  </vs-button>
                  <vs-button style="background-color: #008000 !important; color: #fff !important;"
                    type="border"
                    size="small"
                    @click="confirmPayment(request.requestId)"
                  >
                    Ödeme Teyiti
                  </vs-button>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-popup>
    </vs-row>
  </div>
</template>
<script>
import { GetCloudRequests, CancelCloudRequest, ConfirmCloudRequest } from "@/api/PavoCloud";
export default {
  data(){
    return {
      requests:[],
      isActive:false
    }
  },
   watch:{
    async isActive(val){
      if(val == false){
        this.requests = [];
      }else{
        this.requests = (await GetCloudRequests()).data;
        console.log(this.requests);
      }
    }
  },
  mounted(){
    this.requests =  GetCloudRequests();
    console.log(this.requests);
  },
  methods:{
    confirmDelete(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Silme İşlemi',
        text: 'Bu ödeme isteğini silmek istediğinizden emin misiniz?',
        accept: () => this.cancelRequest(id),
        acceptText: 'Evet',
        cancelText: 'Hayır'
      })
    },
    confirmPayment(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Ödeme Teyiti',
        text: 'Bu ödeme isteğini onaylamak istediğinizden emin misiniz?',
        accept: () => this.confirmRequest(id),
        acceptText: 'Evet',
        cancelText: 'Hayır'

      })
    },


    async cancelRequest(id){
      try {
        await CancelCloudRequest(id);
        this.requests = (await GetCloudRequests()).data;
        this.$vs.notify({
          color: "success",
          title: "Başarılı !",
          text: "Ödeme isteği silindi"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası"
        });
      }
    },
    async confirmRequest(id){
      try {
        await ConfirmCloudRequest(id,this.$currentUser.branch.id);
        this.requests = (await GetCloudRequests()).data;
        this.$emit('refreshBranchMap');
        this.$vs.notify({
          color: "success",
          title: "Başarılı !",
          text: "Ödeme isteği onaylandı"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",

          title: "Hata !",
          text: "Sunucu Bağlantı Hatası"
        });
      }
    }
  }
}

</script>
<style>
.table-responsive {
  padding: 20px;
}

.vs-table {
  width: 100%;
  border-collapse: collapse;
}

.vs-table th,
.vs-table td {
  padding: 12px;
  border: 1px solid #eee;
  text-align: left;
}

.pavo-products-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.pavo-products-list li {
  margin-bottom: 4px;
}
</style>
